module.exports = __webpack_public_path__ + "static/media/Quest-Relics_and_Revenge.39675d40.png";